import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c1118b16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1118b16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1118b16')) {
      api.createRecord('c1118b16', component.options)
    } else {
      api.reload('c1118b16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c1118b16&scoped=true", function () {
      api.rerender('c1118b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/logic/index.vue"
export default component.exports